import { redirect, RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { DDE_MENU_ICONS } from '@/router/icons'
import { PlayerDataView } from '@/views/DataAdmin/PlayerDataView'
import { TournamentsView, TournamentView } from '@/views/DataAdmin/TournamentsView'

export const dataAdminRoutes: RouteObject[] = [
  {
    path: 'data-admin',
    label: 'Data Admin',
    platforms: [PLATFORM.DDE],
    icon: DDE_MENU_ICONS.DATA_ADMIN,
    exact: true,
    children: [
      {
        index: true,
        platforms: [PLATFORM.DDE],
        loader: () => redirect('./player-data/players')
      },
      {
        path: 'player-data/*',
        label: 'Player Data',
        platforms: [PLATFORM.DDE],
        element: <PlayerDataView />,
        loader: async ({ params }) => params['*']
      },
      {
        path: 'tournaments',
        label: 'Tournaments',
        platforms: [PLATFORM.DDE],
        children: [
          {
            index: true,
            element: <TournamentsView />,
            platforms: [PLATFORM.DDE]
          },
          {
            path: ':tournamentId',
            element: <TournamentView />,
            platforms: [PLATFORM.DDE]
          }
        ]
      }
    ]
  }
]
